var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerfil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0269 3.10901C14.9665 3.10924 17.1021 5.55144 17.1021 8.29553C17.1019 10.9888 14.9667 13.4818 12.0269 13.4821C9.03421 13.4821 6.8981 10.9893 6.89795 8.29553C6.89795 5.55095 9.03441 3.10901 12.0269 3.10901ZM12.0269 4.46741C9.83632 4.46741 8.3208 6.30493 8.3208 8.29553C8.32095 10.2352 9.83602 12.0729 12.0269 12.0729C14.1641 12.0726 15.6791 10.2356 15.6792 8.29553C15.6792 6.30457 14.1638 4.46765 12.0269 4.46741Z",
    fill: "#444242",
    stroke: "#444242",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1543 14.7288C16.9207 14.7288 19.1229 17.0124 19.123 19.762V20.8909H17.7559V19.762C17.7557 17.7858 16.1545 16.1643 14.1543 16.1643H9.84473C7.89485 16.1644 6.24432 17.7863 6.24414 19.762V20.8909H4.87695V19.762C4.87713 17.0121 7.12943 14.7289 9.84473 14.7288H14.1543Z",
    fill: "#444242",
    stroke: "#444242",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/Perfil.114a4000a946e4806aa6c03162d1f30b.svg";
export { ForwardRef as ReactComponent };